import { Kushki } from '@kushki/js';
import API_URLS from '../../../../../constants/api-urls';
import axios from '../../../../../utils/axios';
import session from '../../../../../utils/session';
import { LATINA_COUNTRY_CODE } from '../../../../../constants/latina-country';
import { getMobilePathParams } from '../utils/kushki';
import { getZeroInDecimal } from '../../../../../utils/price/get-zero-in-decimal';
import isMobileAppWithDeeplinkRedirect from '../../../../../utils/is-mobile-app';
import { getUserOS, getUserSID } from '../../../../../services/quality-events/quality-events.helpers';
import { KushkiPaymentRequestType } from '../constants/kushki';
import serializeQueryParams from '../../../../../utils/url/serialize-query-params';

export function getKushkiCashToken(props: KushkiPaymentRequestType) {
    const {
        paymentOptionsData,
        kushkiFormData,
        invoiceFormData,
        withInvoice,
        price,
        user,
        currency
    } = props;
    const queryParams = serializeQueryParams();
    const region = paymentOptionsData?.userCountry;
    const finalPrice = getZeroInDecimal(Number(price.replace(',', '.')));
    const countryCodeFromQuery = queryParams?.region;
    const { orderToken } = paymentOptionsData;
    const inMobileAppWithDeeplinkRedirect = isMobileAppWithDeeplinkRedirect() ? '&deepLinkRedirect=true' : '';

    const kushkiCheckout = new Kushki({
        inTestEnvironment: paymentOptionsData.kushkiEnv.inTestEnvironment,
        merchantId: paymentOptionsData.kushkiEnv.merchantId
    });

    return new Promise((resolve) =>
        kushkiCheckout.requestCashToken(
            // @ts-ignore
            {
                currency: currency as never,
                description: 'Pago de bienes en eduki.com',
                documentType: kushkiFormData.documentType,
                email: user?.email ?? invoiceFormData.email,
                identification: kushkiFormData.documentNumber,
                lastName: kushkiFormData.lastName,
                name: kushkiFormData.firstName,
                // @ts-ignore
                totalAmount:
                    region === LATINA_COUNTRY_CODE.CL || region === LATINA_COUNTRY_CODE.CO
                        ? finalPrice
                        : Number(price.replace(',', '.'))
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            async (response: any) => {
                if (response.token) {
                    const postBody = () => {
                        if (session.isLoggedIn()) {
                            return withInvoice
                                ? { token: response.token, ...invoiceFormData, sid: getUserSID(), ...(getUserOS() && { os: getUserOS() }) }
                                : { acceptAgb: invoiceFormData.acceptAgb, token: response.token, sid: getUserSID(), ...(getUserOS() && { os: getUserOS() }) };
                        }
                        const paymentFormData = withInvoice
                            ? invoiceFormData
                            : { acceptAgb: invoiceFormData.acceptAgb, email: invoiceFormData.email };

                        return { ...paymentFormData, token: response.token, sid: getUserSID(), ...(getUserOS() && { os: getUserOS() }) };
                    };

                    const data = await axios.post(
                        countryCodeFromQuery
                            ? `${API_URLS.PAYMENT_ATTEMPT}/KushkiCash?countryCode=${countryCodeFromQuery}&currencyCode=${currency}&orderToken=${orderToken}${inMobileAppWithDeeplinkRedirect}${getMobilePathParams()}`
                            : `${API_URLS.PAYMENT_ATTEMPT}/KushkiCash?currencyCode=${currency}&orderToken=${orderToken}${inMobileAppWithDeeplinkRedirect}${getMobilePathParams()}`,
                        postBody()
                    );

                    resolve(data);
                } else {
                    console.error('Error: ', response.error, 'Code: ', response.code, 'Message: ', response.message);
                    resolve({ code: response.code, error: response.error, message: response.message });
                }
            }
        )
    );
}
